
import axios from 'axios';
import config from '../../config';
import { Error, API } from './base';


class Account {
    constructor(obj){
        Object.assign(this, obj)
    }
}


class AccountsAPI extends API {

    url() {
        return config.get("re.url") + "accounts";
    }


    urlAccountsList(){
        // TODO - Extraer al archivo de config cuando todas las uries estén 100% definidas.
        return "https://sinexiar.com/smre/management/clients/accounts"
    }

    urlAccount(){
        // TODO - Extraer al archivo de config cuando todas las uries estén 100% definidas.
        return "https://sinexiar.com/smre/management/clients/accounts"
    }

    getAll(filters) {
        return new Promise((resolve, reject) => {
            axios.get(
                encodeURI(this.urlAccountsList()+(filters != null ? filters: '')),
                this._getHeaders(),

            ).then(response => {
                if (response.status === 200) {
                    const accounts = [];
                    response.data.accounts.forEach(a => {
                      accounts.push(new Account(a));
                    });
                    resolve(accounts);
                } else {
                    const err = new Error(response.status, "Failed to fetch accounts", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    get(id) {
        return new Promise((resolve, reject) => {
            axios.get(
                this.urlAccount() + "/"+ id,
              this._getHeaders(),

            ).then(response => {
                if (response.status === 200) {
                    resolve(new Account(response.data.accounts[0]));
                } else {
                    const err = new Error(response.status, "Failed to fetch account", JSON.stringify(response.data));
                    reject(err);
                }

            }).catch(err => {
                reject(err);
            });
        })
    }

    update(account) {
        return new Promise((resolve, reject) => {
            axios.put(
                this.url() +"/"+ account.id,
                account,
                this._getHeaders(),
            ).then(response => {
                if (response.status >= 200 && response.status < 400) {
                    resolve();
                } else {
                    const err = new Error(response.status, "Failed to update account", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }

    delete(id) {
        return new Promise((resolve, reject) => {
            axios.delete(
                this.url() +"/" + id,
                this._getHeaders(),
            ).then(response => {
                if (response.status >= 200 && response.status < 400) {
                    resolve();
                } else {
                    const err = new Error(response.status, "Failed to delete account", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }

    create(account) {
        return new Promise((resolve, reject) => {
            axios.post(
                this.url(),
                account,
                this._getHeaders(),
            ).then(response => {
                if (response.status === 201) {
                    resolve(new Account(response.data.account));
                } else {
                    const err = new Error(response.status, "Failed to create account", JSON.stringify(response.data));
                    reject(err);
                }
            }).catch(err => {
                reject(err);
            });
        });
    }
}

export {
    AccountsAPI, Account
};